/* eslint-disable react/jsx-props-no-spreading */
import MediaQuery from 'react-responsive';
import { useHistory, useParams } from 'react-router';

import { setChartActiveTab } from 'actions/tradingView';
import ContractExpiry from 'components/contractExpiry';
import ChartScreen from 'components/placeorder_v2/ChartScreen';
// import ProductHeader from 'components/productHeader';
import Render from 'components/render';
import WidgetTabs from 'components/tabs';
import { urlContractTypeRedirection } from 'constants/constants';
import routes from 'constants/routes';
import { device } from 'helpers/screenSizes';
import i18n from 'i18n/config';
import { socketActiveSelector } from 'selectors/socketSelectors';
import { isOnlineSelector, selectedProductSelector } from 'selectors/tradeSelectors';
import { useAppDispatch, useAppSelector } from 'storeHooks';
import Box from 'UIKit/Box';
import TabButton from 'UIKit/TabButton';

import { CHART_TABS } from './chart.constants';
import classes from './index.module.scss';
import TradingViewContainer from './LoadTradingviewContainer';

const getTradingTranslations = i18n.getFixedT(null, `trading`, 'charts');

const TradingChartContainerNewTab = ({ ...props }) => {
  const history = useHistory();
  const params = useParams<{
    chartType: string;
    contractType: string;
    assetSymbol: string;
    productSymbol: string;
  }>();
  const socketActive = useAppSelector(socketActiveSelector);
  const isOnline = useAppSelector(isOnlineSelector);
  const selectedProduct = useAppSelector(selectedProductSelector);
  const appDispatch = useAppDispatch();

  const isProductExpired = selectedProduct && selectedProduct.state === 'expired';

  const defaultTabList = [
    {
      label: getTradingTranslations('priceChart'),
      id: CHART_TABS.PRICE_CHART,
      tabName: 'Traded Price',
      testId: `charts-tab-${CHART_TABS.PRICE_CHART}`,
    },
    {
      label: getTradingTranslations('markChart'),
      id: CHART_TABS.MARK_CHART,
      tabName: 'Mark Price',
      testId: `charts-tab-${CHART_TABS.MARK_CHART}`,
    },
  ];

  // eslint-disable-next-line react/jsx-props-no-spreading
  const handleTabChange = (tab: (typeof defaultTabList)[number]) => {
    appDispatch(setChartActiveTab(tab.id));
    history.push(
      `${routes.default}tradingview/${tab.id}/${params.contractType}/${params.assetSymbol}/${params.productSymbol}`
    );
  };

  return (<>
    <MediaQuery query={device.up.md}>
      {/* <ProductHeader /> */}
      <WidgetTabs
        data-testid="full-view--chart-tabs"
        tabList={defaultTabList}
        activeTab={params?.chartType || CHART_TABS.PRICE_CHART}
        onClick={handleTabChange}
        tabLength={50}
        className={classes.fullScreenChartTabs}
      />
      <TradingViewContainer {...props} key={`${socketActive}-${isOnline}`} />
    </MediaQuery>
    <MediaQuery query={device.down.md}>
      <Box className={classes.mobileFullScreenChartContainer}>
        <Box as="ul" className={classes.chartTypeTabList}>
          {defaultTabList.map(tab => {
            return (
              (<li key={tab.id} data-palette="TradingChartContainerNewTab">
                <TabButton
                  className={classes.tabButton}
                  title={tab.label}
                  testId={tab.testId}
                  data-testid={tab.testId}
                  onClick={() => handleTabChange(tab)}
                  isParentPrimaryBackground
                  active={tab.id === params.chartType}
                />
              </li>)
            );
          })}
          <li className={classes.chartScreen}>
            <ChartScreen />
          </li>
        </Box>
        <Box flex="flex" flexDir="row" className={classes.chartContainer}>
          <div>
            <TradingViewContainer
              {...props}
              key={`${socketActive}-${isOnline}`}
              fullScreen
            />
          </div>
          {/* <div>
            <ChartScreen />
          </div> */}
        </Box>
      </Box>
    </MediaQuery>
    <Render when={isProductExpired}>
      <ContractExpiry
        contract_type={urlContractTypeRedirection(selectedProduct?.contract_type)}
      />
    </Render>
    {/* <TradingViewContainer {...props} key={`${socketActive}-${isOnline}`} fullView />; */}
  </>);
};

export default TradingChartContainerNewTab;
